<template>
  <v-card flat height="67vh">
    recmain
  </v-card>
</template>

<script>
export default {
  name: 'RecentMediaWindow'
}
</script>
